import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useResendSignupVerificationOtp = () => {
  const request = useHttps();
  const [loadingResendPasswd, setLoadingResendPasswd] = useState(false);

  const onResendSignupVerificationOtpError = (
    err: AxiosError<ErrorHttpResponse>
  ) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onResendSignupVerificationOtp = ({ data }: SuccessHttpResponse<any>) => {
  };

  const resendSignupVerificationOtp = (email: string) => {
    const url: HttpConfig = {
      url: `api/v1/auth/request-verification-token?email=${email}`,
      method: 'get',
    };

    request(
      url,
      onResendSignupVerificationOtp,
      setLoadingResendPasswd,
      onResendSignupVerificationOtpError
    );
  };

  return {
    loadingResendPasswd,
    resendSignupVerificationOtp,
  };
};

export default useResendSignupVerificationOtp;
